import React from "react";
import { TableColumn } from "../../../../components/table/Table";
import { Template, TemplateDetails } from "../../../../models";
import TemplateActionsDropdown from "./TemplateActionsDropdown";
import {
  AccountTag,
  ArticlesCountCell,
  AutoScheduleCell,
  BoolIconCell,
  BrandPersonaCell,
  DestinationLogoCell,
  StatusCell,
  TitleCell,
} from "./TemplateCells";

export const getTemplateColumns = (
  handleViewArticle: (templateName: string) => void
): TableColumn<Template>[] => {
  return [
    {
      key: "name",
      title: "Title",
      headerClassName: "text-start w-[40%]",
      render: (t) => <TitleCell t={t} />,
    },
    {
      key: "brand",
      title: "Brand Persona",
      headerClassName: "text-center w-[15%]",
      cellClassName: "text-left md:text-center",
      render: (t) => <BrandPersonaCell t={t} />,
    },
    {
      key: "isAutoEnabled",
      title: "Auto",
      headerClassName: "text-center w-[20%]",
      render: (t) => <AutoScheduleCell t={t} />,
    },
    {
      key: "includeImage",
      title: "Image",
      headerClassName: "text-center w-[5%]",
      render: (t) => (
        <BoolIconCell
          value={t.includeImage}
          alt="Include Image"
        />
      ),
    },
    {
      key: "includeFaq",
      title: "FAQ",
      headerClassName: "text-center w-[5%]",
      render: (t) => (
        <BoolIconCell
          value={t.includeFaq}
          alt="Include FAQ"
        />
      ),
    },
    {
      key: "articleCount",
      title: "Articles",
      headerClassName: "text-start w-[5%]",
      render: (t) => (
        <ArticlesCountCell
          t={t as TemplateDetails}
          onView={handleViewArticle}
        />
      ),
    },
    {
      key: "accountTagName",
      title: "Tag",
      headerClassName: "text-start w-[5%]",
      cellClassName: "max-w-28",
      render: (t) => (
        <AccountTag accountTagName={(t as TemplateDetails)?.accountTagName!} />
      ),
    },
    {
      key: "destinationInfoList",
      title: "Destination",
      headerClassName: "text-center w-[5%]",
      render: (t) =>
        t.destinationInfoList?.[0] ? (
          <DestinationLogoCell info={t.destinationInfoList[0]} />
        ) : null,
    },
    {
      key: "templateStatusId",
      title: "Status",
      headerClassName: "text-start w-[5%]",
      render: (t) => (
        <StatusCell
          t={t}
          onView={handleViewArticle}
        />
      ),
    },
    {
      key: "templateId",
      title: "",
      headerClassName: "text-start w-[5%]",
      render: (t) => {
        return (
          <TemplateActionsDropdown
            id={t.templateId!}
            name={t.name!}
            status={t.templateStatusId}
            isAuto={t.isAutoEnabled}
            accountTagId={t.accountTagId}
          />
        );
      },
    },
  ];
};
